import { Inject, InjectionToken, OnDestroy, OnInit, QueryList, ViewChildren, Directive } from '@angular/core';
import { ItemsListRowComponent } from '../../list-row/list-row.component';
import { Subject } from 'rxjs';

export const ItemsListContentBaseComponent_settings = new InjectionToken('ItemsListContentBaseComponent_settings');
export const ItemsListContentBaseComponent_processRowChecked = new InjectionToken<Subject<void>>(
    'ItemsListContentBaseComponent_processRowChecked',
);

@Directive()
export abstract class ItemsListContentBaseComponent implements OnInit, OnDestroy {
    @ViewChildren('listItem') listItems: QueryList<ItemsListRowComponent<any>>;

    constructor(
        @Inject(ItemsListContentBaseComponent_settings) public ngModel,
        @Inject(ItemsListContentBaseComponent_processRowChecked) private processRowChecked$,
    ) {}

    /* processRowsChecked() {
        this.listItems.forEach(item => {
            item.processCheckedItem();
        })
    }*/

    isParentCollapsed(data) {
        return (
            data &&
            ((this.ngModel.collapsedParents.indexOf(data) > -1 && this.ngModel.ChildrenInitiallyCollased === false) ||
                (this.ngModel.collapsedParents.indexOf(data) === -1 && this.ngModel.ChildrenInitiallyCollased === true))
        );
    }

    isHasChildren(data) {
        return this.ngModel.getChildrenDataItems(data).length > 0;
    }

    toggleChildrenItems($event, data) {
        $event.stopPropagation();
        $event.preventDefault();

        this.ngModel.toggleChildrenItems(data);
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    // note: not used ?
    ngOnInit(): void {
        //this.processRowChecked$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(() => this.processRowsChecked());
    }
}
